import {Moment} from 'moment';
import {IEmployee} from './employee.model';
import {ITransaction} from "./transaction.model";
import {ICustomer} from "./customer.model";
import {IOrganization, Organization} from "./organization.model";
import {IProject} from "./project.model";
import {ISalesCycle} from "./salesCycle.model";

export interface IContract {
  id?: number;
  itemName?: string;
  status?: string;
  type?: string;
  description?: string;
  cost?: any;
  createdBy?: any;
  employee_str?: any;
  contractNumber?: string;
  start?: string;
  startDate?: any;
  project_str?: any;
  salesCycle_str?: any;
  end?: string;
  endDate?: any;
  isdeleted?: any;
  closed?: any;
  lastModifiedBy?: any;
  createdDate?: any;
  lastModifiedDate?: any;
  employee?: IEmployee;
  customer?: ICustomer;
  project?: IProject;
  salesCycle?: ISalesCycle;
  organization?: IOrganization;
  transactions?: ITransaction[];

}

export class Contract implements IContract {
  constructor(public id?: number,
              public itemName?: string,
              public status?: string,
              public description?: string,
              public cost?: any,
              public project_str?: any,
              public employee_str?: any,
              public contractNumber?: string,
              public startDate?: any,
              public endDate?: any,
              public createdDate?: any,
              public organization?: Organization,
              public employee?: IEmployee,
              public project?: IProject,
              public transactions?: ITransaction[],
              public salesCycle?: ISalesCycle
  ) {
  }
}
